import PropTypes from 'prop-types';
import { Box } from '@mui/material';

export default function PollutionBadge(props) {
  const {
    badge = 0,
    size = 'medium',
  } = props;

  return (
    <Box
      component="span"
      sx={{
        position: 'relative',
        display: 'inline-block',
        borderColor: 'black',
        borderStyle: 'solid',
        borderRadius: '50%',
        textAlign: 'center',
        fontWeight: 'bold',
        '&::before': {
          position: 'absolute',
          display: 'block',
          content: '""',
          zIndex: -1,
          borderRadius: '50%',
          borderColor: '#e3e1df',
          backgroundColor: '#e3e1df',
          borderStyle: 'solid',
        },
        ...getSizeStyles(size),
        ...getBadgeStyles(badge),
      }}
    >
      {badge}
    </Box>
  );
}

PollutionBadge.propTypes = {
  badge: PropTypes.number,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
};

const SIZES = {
  // Small
  small: 18,
  smallBorder1: 1,
  smallBorder2: 4,
  // Medium
  medium: 26,
  mediumBorder1: 1,
  mediumBorder2: 4,
  // Large
  large: 48,
  largeBorder1: 2,
  largeBorder2: 8,
};

function getSizeStyles(size) {
  switch (size) {
    case 'small':
      return {
        width: SIZES.small,
        height: SIZES.small,
        lineHeight: `${SIZES.small - 2}px`,
        borderWidth: SIZES.smallBorder1,
        '&::before': {
          width: SIZES.small + SIZES.smallBorder2 * 2,
          height: SIZES.small + SIZES.smallBorder2 * 2,
          top: SIZES.smallBorder2 * -1 - SIZES.smallBorder1,
          left: SIZES.smallBorder2 * -1 - SIZES.smallBorder1,
          borderWidth: SIZES.smallBorder2,
        },
      };
    case 'medium':
      return {
        width: SIZES.medium,
        height: SIZES.medium,
        lineHeight: `${SIZES.medium - 3}px`,
        borderWidth: SIZES.mediumBorder1,
        '&::before': {
          width: SIZES.medium + SIZES.mediumBorder2 * 2,
          height: SIZES.medium + SIZES.mediumBorder2 * 2,
          top: SIZES.mediumBorder2 * -1 - SIZES.mediumBorder1,
          left: SIZES.mediumBorder2 * -1 - SIZES.mediumBorder1,
          borderWidth: SIZES.mediumBorder2,
        },
      };
    case 'large':
      return {
        width: SIZES.large,
        height: SIZES.large,
        lineHeight: `${SIZES.large - 2}px`,
        borderWidth: SIZES.largeBorder1,
        '&::before': {
          width: SIZES.large + SIZES.largeBorder2 * 2,
          height: SIZES.large + SIZES.largeBorder2 * 2,
          top: SIZES.largeBorder2 * -1 - SIZES.largeBorder1,
          left: SIZES.largeBorder2 * -1 - SIZES.largeBorder1,
          borderWidth: SIZES.largeBorder2,
        },
      };
    default:
      return {};
  }
}

function getBadgeStyles(badge) {
  switch (BADGE_CLASSNAME[badge]) {
    case 'none':
      return {};
    case 'group2':
      return {
        color: 'white',
        backgroundColor: '#c1121c',
      };
    case 'group3':
      return {
        backgroundColor: '#f0ca00',
      };
    case 'group4':
      return {
        color: 'white',
        backgroundColor: '#008351',
      };
    default:
      return {};
  }
}

const BADGE_CLASSNAME = {
  0: 'none',
  1: 'none',
  2: 'group2',
  3: 'group3',
  4: 'group4',
};
